/* ============================================================
   VURGE STUDIOS — Product Detail Page JavaScript
   - ATC button with live price display
   - Image carousel with swipe + dot indicators
   - Stock indicator (low / in-stock)
   ============================================================ */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', initVurgePDP);

  function initVurgePDP() {
    initCarousel();
    initATCButton();
    initStockIndicator();
  }

  /* ── Image Carousel ── */
  function initCarousel() {
    const carousel = document.querySelector('.vurge-carousel');
    if (!carousel) return;

    const track = carousel.querySelector('.vurge-carousel__track');
    const slides = carousel.querySelectorAll('.vurge-carousel__slide');
    const dotsContainer = carousel.querySelector('.vurge-carousel__dots');

    if (!track || slides.length === 0) return;

    let current = 0;
    let startX = 0;
    let startTime = 0;

    /* Build dots */
    if (dotsContainer && slides.length > 1) {
      slides.forEach(function (_, i) {
        const dot = document.createElement('button');
        dot.className = 'vurge-carousel__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.addEventListener('click', function () { goTo(i); });
        dotsContainer.appendChild(dot);
      });
    }

    function goTo(index) {
      current = Math.max(0, Math.min(index, slides.length - 1));
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      if (dotsContainer) {
        dotsContainer.querySelectorAll('.vurge-carousel__dot').forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === current);
        });
      }
    }

    /* Touch/swipe support */
    track.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      startTime = Date.now();
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
      const diff = startX - e.changedTouches[0].clientX;
      const elapsed = Date.now() - startTime;
      if (Math.abs(diff) > 40 && elapsed < 500) {
        goTo(diff > 0 ? current + 1 : current - 1);
      }
    }, { passive: true });

    /* Mouse drag for desktop */
    let mouseDown = false;
    let mouseStartX = 0;

    track.addEventListener('mousedown', function (e) {
      mouseDown = true;
      mouseStartX = e.clientX;
      startTime = Date.now();
    });

    track.addEventListener('mouseup', function (e) {
      if (!mouseDown) return;
      mouseDown = false;
      const diff = mouseStartX - e.clientX;
      const elapsed = Date.now() - startTime;
      if (Math.abs(diff) > 40 && elapsed < 500) {
        goTo(diff > 0 ? current + 1 : current - 1);
      }
    });

    track.addEventListener('mouseleave', function () {
      mouseDown = false;
    });

    /* Prevent click-through during drag */
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  /* ── ATC Button: live price from selected variant ── */
  function initATCButton() {
    const form = document.querySelector('product-form form[data-type="add-to-cart-form"]');
    if (!form) return;

    const submitBtn = form.querySelector('[name="add"]');
    if (!submitBtn) return;

    /* Get product data */
    const productDataEl = document.getElementById('product-json');
    let productData = null;

    if (productDataEl) {
      try {
        productData = JSON.parse(productDataEl.textContent);
      } catch (e) {}
    }

    /* Wrap button contents so we can update just the price */
    if (!submitBtn.querySelector('.vurge-atc-label')) {
      submitBtn.innerHTML =
        '<span class="vurge-atc-label">ADD TO CART</span>' +
        '<span class="vurge-atc-price"></span>' +
        '<span class="vurge-atc-checkmark">✓</span>' +
        '<div class="loading__spinner hidden">' +
          '<svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">' +
            '<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>' +
          '</svg>' +
        '</div>';
    }

    function updateButtonPrice() {
      if (!productData) return;
      const variantInput = form.querySelector('[name="id"]');
      if (!variantInput) return;
      const variantId = parseInt(variantInput.value);
      const variant = productData.variants.find(function (v) { return v.id === variantId; });
      if (!variant) return;

      const priceEl = submitBtn.querySelector('.vurge-atc-price');
      if (priceEl) {
        priceEl.textContent = '— ' + formatMoney(variant.price);
      }

      const labelEl = submitBtn.querySelector('.vurge-atc-label');
      if (labelEl) {
        if (!variant.available) {
          labelEl.textContent = 'SOLD OUT';
          submitBtn.disabled = true;
        } else {
          labelEl.textContent = 'ADD TO CART';
          submitBtn.disabled = false;
        }
      }
    }

    /* Update on variant change */
    form.addEventListener('change', updateButtonPrice);

    /* Also watch for URL param changes (Dawn updates variant via URL) */
    const observer = new MutationObserver(updateButtonPrice);
    const variantInput = form.querySelector('[name="id"]');
    if (variantInput) {
      observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
    }

    updateButtonPrice();

    /* Confirmation flash on successful add */
    form.addEventListener('submit', function () {
      setTimeout(function () {
        submitBtn.classList.add('vurge-atc-confirmed');
        setTimeout(function () {
          submitBtn.classList.remove('vurge-atc-confirmed');
        }, 700);
      }, 100);
    });
  }

  /* ── Stock Indicator ── */
  function initStockIndicator() {
    const indicator = document.querySelector('.vurge-stock-indicator');
    if (!indicator) return;

    const productDataEl = document.getElementById('product-json');
    if (!productDataEl) return;

    let productData;
    try {
      productData = JSON.parse(productDataEl.textContent);
    } catch (e) {
      return;
    }

    function updateStock() {
      const variantInput = document.querySelector('product-form form [name="id"]');
      if (!variantInput) return;
      const variantId = parseInt(variantInput.value);
      const variant = productData.variants.find(function (v) { return v.id === variantId; });
      if (!variant) return;

      const qty = variant.inventory_quantity;
      const managed = variant.inventory_management === 'shopify';

      if (!managed || !variant.available) {
        indicator.style.display = 'none';
        return;
      }

      indicator.style.display = 'flex';

      if (qty !== null && qty <= 5 && qty > 0) {
        indicator.textContent = '⚡ Low Stock — Order Soon';
        indicator.className = 'vurge-stock-indicator vurge-stock-indicator--low';
      } else if (qty === null || qty > 5) {
        indicator.textContent = '✓ In Stock — Ready to Ship';
        indicator.className = 'vurge-stock-indicator vurge-stock-indicator--in-stock';
      }
    }

    /* Watch for variant changes */
    document.addEventListener('change', function (e) {
      if (e.target.closest('product-form form')) {
        setTimeout(updateStock, 50);
      }
    });

    updateStock();
  }

  /* ── Utilities ── */
  function formatMoney(cents) {
    const dollars = cents / 100;
    return '$' + dollars.toFixed(2).replace(/\.00$/, '');
  }

})();
